// extracted by mini-css-extract-plugin
export default {"programTitle":"styles_programTitle__e8DJw","programBox":"styles_programBox__ls-ec","separator-line":"styles_separator-line__l0Eqw"};